<div class="img-manager-container" *ngIf="showImageManager">
  <div *ngIf="selectedImageFiles.length > 0" class="images">
    <div *ngFor="let imageFile of selectedImageFiles">
      <div>
        <app-closable-image-chip [imageFile]="imageFile" (onDelete)="removeImageFile($event)"/>
      </div>
    </div>
  </div>
</div>
